<template>
  <div
    :class="{ 'invoice-page--mobile': !isDesktopLayout }"
    :style="!isDesktopLayout ? mobilePageStyle : null"
  >
    <invoice-desktop-bridge v-if="isDesktopLayout" />
    <invoice-mobile v-else ref="invoiceMobile" />
  </div>
</template>

<script>
import Task from "../task/task";
import General from "../../../../Mixins/general";
import autocomplete from "../../components/general/patial/autocomplete";
import Description from "../../components/general/description/Description";
import print from "../../components/general/printViewer/printViewer";
import FormAttachmentDoc from "../../components/general/FormAttachmentDoc";
import investors from "./partial/investors.vue";
import customFields from "../../components/general/customFields/index.vue";
import payments from "./partial/payments.vue";
import Composite from "./partial/Composite.vue";
import InvoiceTableRow from "./partial/InvoiceTableRow.vue";
import MyIcon from "@/views/dashboard/components/general/icon/MyIcon.vue";
import SerialManagementDialog from "../../components/general/serials/SerialManagementDialog";
import { VListGroup } from "vuetify/lib";
import {
  applyColumnSettings,
  loadColumnSettings,
} from "@/plugins/columnSettings/columnSettings";
import InvoiceDesktopBridge from "./layouts/desktop/InvoiceDesktopBridge.vue";
import InvoiceMobile from "./layouts/mobile/InvoiceMobile.vue";
import HeaderDiscountModeDialog from "./partial/HeaderDiscountModeDialog.vue";

const INVOICE_DESKTOP_MIN_WIDTH = 800;

export default {
  name: "InvoiceIndex",
  components: {
    InvoiceDesktopBridge,
    InvoiceMobile,
    HeaderDiscountModeDialog,
    Products: () => import("../../components/general/Products/Products"),
    Tag: () => import("../../components/general/Tag/tag"),
    Status: () => import("../../components/general/Status/status"),
    customFields,
    Description,
    investors,
    FormAttachmentDoc,
    print,
    payments,
    autocomplete,
    Task,
    Composite,
    InvoiceTableRow,
    MyIcon,
    SerialManagementDialog,
  },
  mixins: [General],
  props: ["input", "formType", "refId", "accountProp", "itemsProp", "metaProp"],
  provide() {
    return {
      invoice: this,
    };
  },
  data: () => ({
    priceType: "fixedPrice",
    priceTypeItems: [],
    pattern: 1,
    goldTotal: 0,
    invoicePattern: 1,
    inquiryDialog: false,
    inquiryMessage: null,
    invoiceTypeItems: null,
    paymentDialog: null,
    itemDialog: null,
    selected: [],
    goldDialog: false,
    checkDiscountEdit: false,
    render: true,
    // bugfix //timing render invoice each row — single shared product editor (edit mode)
    sharedProductEdit: {
      warmed: false,
      active: false,
      loading: false,
      loadingIndex: null,
      item: null,
      index: null,
      style: null,
      listenersBound: false,
    },
    calcSumTimer: null,
    invoiceTab: 0,
    validBank: true,
    contractNumber: null,
    notifications: null,
    customFields: null,
    refInvoice: null,
    investors: null,
    attachments: null,
    commissionAmount: null,
    commissionPercent: null,
    given: null,
    officialNumber: null,
    tableHeightInvoice: 380,
    showCurrency: true,
    reportData: null,
    reportName: null,
    seller: null,
    plan: null,
    percentDiscountStatus: false,
    bodyStatus: false,
    dialogPriceChange: false,
    allowPriceChange: false,
    printDialog: false,
    discountEdit: 0,
    checkNumber: false,
    checkOfficialNumber: false,
    deletDialog: false,
    serialDialog: false,
    serialsLoading: false,
    serialPage: 1,
    serialLastPage: 1,
    serialSearch: "",
    serialCancelToken: null,
    serialRequestId: 0,
    serialItem: null,
    showClearing: true,
    showSelect: false,
    showProductList: false,
    clearingStatus: false,
    filter: false,
    valid: true,
    number: null,
    bank: null,
    entrepot: null,
    payments: null,
    checks: null,
    account: null,
    dueDate: null,
    date: null,
    currency_amount: null,
    content: null,
    model: null,
    printType: "normal",
    from: 1,
    taskDialog: null,
    id: null,
    status: null,
    tag: null,
    currency: null,
    temp: null,
    taxPercent: null,
    deleteItem: null,
    sellStatus: null,
    items: [],
    typeItems: [],
    sortBy: [],
    dialog: null,
    timer: 0,
    priceTimers: {},
    totalItems: 1000,
    isLoading: false,
    snakbar: false,
    type: "sell",
    taskId: null,
    patternItems: [],
    snakbarText: null,
    loading: true,
    tableOptions: {
      itemsPerPage: 1000,
    },
    headers: null,
    search: null,
    discountPercent: false,
    taxStatus: "active",
    totalCount: 0,
    discount: 0,
    totalDiscount: 0,
    totalTax: 0,
    totalFee: 0,
    sumRow: 0,
    sum: 0,
    decimal: 0,
    totalDiscountType: false,
    watcher: false,
    comeFromCopy: false,
    compositeTableData: null,
    optionDialogType: null,
    totalPayment: null,
    remainInvoice: null,
    userInfo: null,
    isInvoiceCreated: false,
    editCompositeTableData: null,
    selectedTaxOption: "active",
    POSIP: null,
    POSPORT: null,
    progressPercent: 0,
    returnPosInfo: null,
    isPosSuccessfull: false,
    loadingDialog: false,
    lodingText: null,
    compositeAmount: null,
    configDialog: false,
    posHeaders: [],
    posItems: [],
    addNewPosDialog: false,
    dialogType: null,
    newPos: {
      title: null,
      posDevice: null,
      posIp: null,
      posPort: null,
      bank: null,
      status: null,
    },
    selectedIndex: null,
    isPosActive: false,
    deletePermissionDialog: false,
    isAllItemsDelete: false,
    deletedIndex: null,
    activeTab: 0,
    posesList: [],
    cashAmount: null,
    isFirstLoad: true,
    userId: null,
    userCredit: 0,
    credit_status: false,
    credit: null,
    prevCredit: null,
    discountModeDialog: false,
    pendingHeaderDiscount: null,
    snapshotHeaderDiscount: null,
    snapshotHeaderDiscountPercent: null,
    headerDiscountInputKey: 0,
    _headerDiscountModeSubmitted: false,
    _vaznDistributeJustApplied: false,
    /*       pageCount: 1,
      page: 1 */
  }),
  computed: {
    isDesktopLayout() {
      return this.$vuetify.breakpoint.width >= INVOICE_DESKTOP_MIN_WIDTH;
    },
    // Fill to viewport bottom (under bottom nav) so base grey does not show
    // Mobile bottom nav is dashboard-only; no reserved footer space here.
    mobilePageStyle() {
      const appBar = 52;
      const bottomNav = 0;
      const height = `calc(100dvh - ${appBar}px)`;
      return {
        height,
        maxHeight: height,
        marginBottom: bottomNav ? `-${bottomNav}px` : "0",
        paddingBottom: bottomNav ? `${bottomNav}px` : "0",
        boxSizing: "border-box",
        background: "#fff",
        overflow: "hidden",
      };
    },
    showSerialFeature() {
      return ["purchase", "sell", "returnPurchase", "returnSell", "presale"].includes(
        this.type
      );
    },
    serialFlow() {
      const inputTypes = ["purchase", "returnSell"];
      const outputTypes = ["sell", "returnPurchase", "presale"];
      if (inputTypes.includes(this.type)) return "in";
      if (outputTypes.includes(this.type)) return "out";
      return "in";
    },
    serialDialogList() {
      if (!this.serialItem) return [];
      if (this.serialFlow === "out") {
        return this.serialItem.serialOptions || [];
      }
      return this.serialItem.serials || [];
    },
    serialHasMore() {
      return this.serialFlow === "out" && this.serialPage < this.serialLastPage;
    },
    total: function () {
      var sum =
        parseFloat(this.sum) -
        parseFloat(this.totalDiscount !== "" ? this.totalDiscount : 0);
      this.checkBankRemain(sum);
      return sum.toFixed(this.decimal);
    },
    currencyLabel() {
      const currency = this.currency || this.$store.state.currency;
      return (
        (currency && (currency.symbol || currency.name)) ||
        this.$store.state.currencySymbol ||
        ""
      );
    },
    tableMoneyOptions() {
      return {
        ...(this.options || {}),
        suffix: "",
      };
    },
    invoiceColumnPersistKey() {
      return "invoice-table-columns-" + (this.type || "sell");
    },
    invoiceColumnPlugins() {
      return {
        headers: this.headers,
        visibleHeaders: this.showHeaders,
        locked: ["actions", "row", "product"],
        anchor: "product",
        minWidth: 80,
        persistKey: this.invoiceColumnPersistKey,
      };
    },
    showHeaders() {
      var app = this;
      const currency = app.currencyLabel;
      const moneyColumns = {
        fee: "fee",
        discount: "discount",
        tax: "tax",
        sum: "sum",
      };
      // keep same object refs so pin/resize state stays on headers
      return this.headers
        .filter(function (s) {
          if (s.value === "expire_date") {
            if (app.type !== "purchase") return false;
          }
          return app.headers.includes(s);
        })
        .map(function (s) {
          if (currency && moneyColumns[s.value]) {
            return Object.assign(s, {
              text: app.$t(moneyColumns[s.value]) + " (" + currency + ")",
            });
          }
          return s;
        });
    },
    compositeType() {
      if (
        this.$route.path == "/sell/index" ||
        this.$route.path.includes("/sell/edit") ||
        this.$route.path == "/presale/index" ||
        this.$route.path.includes("/presale/edit") ||
        this.$route.path == "/returnPurchase/index" ||
        this.$route.path.includes("/returnPurchase/edit")
      ) {
        return "recieve";
      }
      if (
        this.$route.path == "/purchase/new" ||
        this.$route.path.includes("/purchase/edit") ||
        this.$route.path == "/returnSell/index" ||
        this.$route.path.includes("/returnSell/edit")
      ) {
        return "pay";
      } else {
        return null;
      }
    },
    taxOption() {
      return [
        { label: this.$t("active"), value: "active" },
        { label: this.$t("deactive"), value: "deactive" },
      ];
    },
    creditAmount() {
      if (this.credit_status) {
        if (Number(this.userCredit) <= Number(this.total)) {
          this.credit = Number(this.userCredit);
          return Number(this.userCredit);
        } else if (Number(this.userCredit) > Number(this.total)) {
          this.credit = Number(this.total);
          return Number(this.total);
        }
      } else {
        this.credit = 0;
        return 0;
      }
    },
  },
  watch: {
    invoiceTab() {
      this.refreshInvoiceFormTabsSlider();
    },
    commissionPermission() {
      this.refreshInvoiceFormTabsSlider();
    },
    type() {
      this.refreshInvoiceFormTabsSlider();
    },
    items: {
      handler(newItems, oldItems) {
        if (newItems && newItems.length > 0) {
          this.$nextTick(() => {
            const table = this.$refs.myTable;
            if (table && table.$el && table.$el.offsetHeight > 0) {
              this.isFirstLoad = false;
            }
          });
        }
        if (Array.isArray(newItems)) {
          newItems.forEach((newItem) => {
            if (
              newItem &&
              newItem.discountPercent !== undefined &&
              !isNaN(newItem.discountPercent)
            ) {
              const num = parseFloat(newItem.discountPercent);
              newItem.discountPercent = parseFloat(num.toFixed(2));
            }
          });
        }
      },
      deep: true,
    },
    investor(val) {},
    showProductList(val, oldVal) {
      if (val) {
        localStorage.setItem("showProductListInvoice", val);
      } else {
        localStorage.removeItem("showProductListInvoice");
      }
    },
    account(val) {
      if (val) {
        if (val.customer_club_credit && val.customer_club_credit.length > 0) {
          this.userCredit = Number(val.customer_club_credit[0].value || 0);
        } else {
          this.userCredit = 0;
        }
        this.userId = val.id;
        // if (this.userId) {
        //   this.fetchUserCredit();
        // }
        this.getPersonInfo(val.id);
        this.checkingProductReturnSellOrPurchus();
      }
      this.updatePrice();
      // this.clearRows()
    },
    branch() {
      this.updatePrice();
    },
    currency(val, old) {
      this.decimal = 0;
      if (val) {
        this.decimal = val.decimal;
        //watch option for find new currency
        this.options = {
          locale: "en-US",
          prefix: "",
          suffix: val.symbol || val.name || this.$store.state.currencySymbol,
          precision: val.decimal ?? 0,
        };
        if (this.render) {
          this.currency_amount = val.amount;
          this.bank = null;
        }
      } else {
        this.currency = this.$store.state.currency;
        this.currency_amount = null;
      }
      if (this.render) {
        // this.clearRows()
      }
    },
    taxStatus(val, old) {
      if (val) {
        this.totalDiscountType = false;
        this.totalDiscount = 0;
        this.discount = 0;
      }
      this.calcSum();
    },
    taxPercent(val, old) {
      if (this.taxStatus) {
        this.totalDiscountType = false;
        this.totalDiscount = 0;
        this.discount = 0;
      }
      this.calcSum();
    },
    discountModeDialog(val, oldVal) {
      if (
        oldVal &&
        !val &&
        this.pendingHeaderDiscount !== null &&
        !this._headerDiscountModeSubmitted
      ) {
        this.onHeaderDiscountModeCancel();
      }
    },
    defaultCurrency() {
      if (this.defaultCurrency && !this.id) {
        this.$refs.refCurrency.setModel(this.defaultCurrency);
        this.currency_amount = this.defaultCurrency.amount;
      }
    },
    cashAmount(val) {
      if (val && !this.defaultCash) {
        this.configDialog = true;
        this.snakbarText = this.$t("pleaseSelectCashForCashPayment");
        this.snakbarColor = "blue";
        this.snakbar = true;
      }
      if (val) {
        var remain = +this.total - +val;
        if (remain > 0) {
          this.paymentAmount = remain;
        }
      }
    },
    refId(val, oldVal) {
      // this.items = []
      this.getItems();
    },
    model() {
      this.$emit("input", this.model);
    },
    selected() {
      this.$emit("input", this.selected.text);
      if (this.selected.length > 0) {
        this.model = this.selected[0].text;
        this.temp = this.selected[0].text;
      }
      this.dialog = false;
    },
    search() {
      var app = this;
      app.loading = true;
      clearTimeout(this.timer);
      this.timer = setTimeout(function () {
        app.getItems();
      }, 1000);
    },
    payments: {
      handler() {
        var app = this;
        app.showClearing = true;
        if (app.payments && app.payments.length > 0) {
          app.payments.map(function (value, key) {
            if (value.chip) {
              app.showClearing = false;
              app.clearingStatus = false;
              app.bank = null;
            }
          });
        }
        // app.checks.map(function (value, key) {
        //   if (value.chip) {
        //     app.showClearing = false
        //     app.clearingStatus = false
        //     app.bank = null
        //   }
        // })
      },
      deep: true,
    },
    tableOptions: {
      handler() {
        var app = this;
        app.sortBy = [];
        app.tableOptions.sortBy.map(function (value, key) {
          const index = app.headers.findIndex((h) => h.value === value);
          app.sortBy.push(app.headers[index].table);
        });
      },
      deep: true,
    },
    sortBy() {
      const index = this.headers.findIndex((h) => h.value === this.sortBy);
      if (index > -1) {
        this.sortBy = this.headers[index].table;
      }
    },
    itemsProp: {
      handler(val) {
        if (val) {
          this.items = val;
          this.$nextTick(() => {
            this.calcSum();
          });
        } else {
          this.items = [];
          this.addRow();
        }
      },
      immediate: true,
      deep: true,
    },
    goldDialog(val) {
      if (!val) {
        this.calcSum();
      }
    },
    totalTax(val) {
      if (val && this.$route.params.id) {
        this.checkTaxStatus();
      }
    },
    selectedTaxOption(val, oldVal) {
      if (this.$route.params.id) return;
      if (!val || val === oldVal) return;
      this.setTaxToggleConfig(val);
    },
    priceType() {
      this.updatePrice();
    },
  },
  activated: function () {
    this.beforeMount();
  },
  beforeMount() {
    this.posHeaders = [
      {
        text: this.$t("active"),
        align: "start",
        sortable: false,
        value: "status",
        width: 30,
      },
      {
        text: this.$t("device-title"),
        align: "start",
        sortable: false,
        value: "title",
      },
      {
        text: this.$t("posType"),
        align: "start",
        sortable: false,
        value: "posDevice",
      },
      {
        text: this.$t("bank"),
        align: "start",
        sortable: false,
        value: "bank",
      },
      {
        text: this.$t("PosIp"),
        align: "start",
        sortable: false,
        value: "posIp",
      },
      {
        text: this.$t("PosPort"),
        align: "start",
        sortable: false,
        value: "posPort",
      },
      {
        text: this.$t("edit"),
        align: "start",
        sortable: false,
        value: "edit",
      },
    ];
    this.invoiceTypeItems = [
      {
        value: 1,
        text: this.$t("firstType"),
      },
      {
        value: 2,
        text: this.$t("secondType"),
      },
      {
        value: 3,
        text: this.$t("thirdType"),
      },
    ];
    this.patternItems = [
      {
        value: "1",
        text: this.$t("pattern1"),
      },
      {
        value: "2",
        text: this.$t("pattern2"),
      },
      {
        value: "3",
        text: this.$t("pattern3"),
      },
      {
        value: "4",
        text: this.$t("pattern4"),
      },
      {
        value: "5",
        text: this.$t("pattern5"),
      },
      {
        value: "6",
        text: this.$t("pattern6"),
      },
      {
        value: "7",
        text: this.$t("pattern7"),
      },
    ];
    // this.beforeMount()
  },
  mounted() {
    if (localStorage.getItem("posDevice")) {
      this.posItems = JSON.parse(localStorage.getItem("posDevice"));
    }
    this.amountDiscount = this.$refs.discountAmount;
    this.getPosInfo();
    if (localStorage.getItem("showProductListInvoice")) {
      this.showProductList = true;
    }
    this.taxPercent = this.$store.state.tax;
    this.getTaxToggleConfig();
    this.refreshInvoiceFormTabsSlider();
    this.headers = [
      {
        text: "#",
        align: "start",
        sortable: false,
        value: "actions",
        width: 40,
        minWidth: 40,
      },
      {
        text: this.$t("row"),
        align: "start",
        sortable: false,
        value: "row",
        width: 40,
        minWidth: 40,
      },
      {
        text: this.$t("product") + "/" + this.$t("service"),
        sortable: false,
        value: "product",
        width: 350,
        minWidth: 160,
      },
      {
        text: this.$t("unit"),
        sortable: false,
        value: "unit",
        width: 130,
        minWidth: 80,
      },
      {
        text: this.$t("count") + " / " + this.$t("weight"),
        sortable: false,
        value: "count",
        width: 125,
        minWidth: 80,
      },
      {
        text: this.$t("fee"),
        sortable: false,
        value: "fee",
        width: 200,
        minWidth: 120,
      },
      {
        text: this.$t("discount"),
        sortable: false,
        value: "discount",
        width: 230,
        minWidth: 140,
      },
      {
        text: this.$t("tax"),
        sortable: false,
        value: "tax",
        width: 220,
        minWidth: 140,
      },
      {
        text: this.$t("sum"),
        sortable: false,
        value: "sum",
        width: 170,
        minWidth: 100,
      },
      {
        text: this.$t("content"),
        sortable: false,
        value: "content",
        width: 300,
        minWidth: 120,
      },
      {
        text: this.$t("entrepot"),
        sortable: false,
        value: "entrepot",
        width: 200,
        minWidth: 100,
      },
      {
        text: this.$t("expireDate"),
        sortable: false,
        value: "expire_date",
        width: 300,
        minWidth: 120,
      },
    ];
    this.loadInvoiceTableColumnSettings();
    var presaleDisable = false;
    if (this.$route.name === "presaleEdit" && this.id) {
      presaleDisable = true;
    }
    this.typeItems = [
      {
        value: "sell",
        text: this.$t("sell"),
      },
      {
        value: "presale",
        text: this.$t("presale"),
      },
      {
        value: "returnSell",
        text: this.$t("returnSell"),
        disable: presaleDisable,
      },
      {
        value: "purchase",
        text: this.$t("purchase"),
        disable: presaleDisable,
      },
      {
        value: "returnPurchase",
        text: this.$t("returnPurchase"),
        disable: presaleDisable,
      },
    ];
    this.priceTypeItems = [
      {
        value: "fixedPrice",
        text: this.$t("fixedPrice"),
      },
      {
        value: "formulaPrice",
        text: this.$t("formulaPrice"),
      },
    ];
    if (this.input) {
      this.model = this.input;
    }
    this.loading = false;
    if (this.$route.params.id === null || this.$route.params.id === undefined) {
      // this.addRow()
      // this.currency = this.$store.state.currency
      // this.currency_amount = this.$store.state.currency.amount
    }
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
    });
    this.composite = this.$refs.composite;
    this.userInfo = JSON.parse(localStorage.getItem("token"));
    if (this.$route.params.id) {
      this.$nextTick(() => {
        this.checkTaxStatus();
      });
    }
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
    this.unbindSharedProductListeners();
    if (this.serialCancelToken) {
      this.serialCancelToken.cancel("Canceled due to destroy");
    }
    Object.keys(this.priceTimers || {}).forEach((key) => {
      clearTimeout(this.priceTimers[key]);
    });
    this.priceTimers = {};
    if (this.calcSumTimer) {
      clearTimeout(this.calcSumTimer);
      this.calcSumTimer = null;
    }
  },
  methods: {
    /** Snackbar + scroll/focus first invalid Vuetify field after form.validate() fails. */
    notifyFormValidationFailed(color = "pink") {
      this.snakbarText = this.$t("please fill the form below");
      this.snakbarColor = color;
      this.snakbar = true;
      this.focusFirstInvalidFormField();
    },
    focusFirstInvalidFormField() {
      this.$nextTick(() => {
        const root = this.$el;
        if (!root || typeof root.querySelector !== "function") return;
        const invalid = root.querySelector(".v-input.error--text, .error--text");
        if (!invalid) return;
        if (typeof invalid.scrollIntoView === "function") {
          invalid.scrollIntoView({ behavior: "smooth", block: "center" });
        }
        const focusable =
          invalid.querySelector &&
          invalid.querySelector("input:not([disabled]), textarea:not([disabled])");
        if (focusable && typeof focusable.focus === "function") {
          try {
            focusable.focus({ preventScroll: true });
          } catch (e) {
            focusable.focus();
          }
        }
      });
    },
    // Keep typing responsive: delay full-table recalculation slightly
    scheduleCalcSum(delay) {
      const wait = typeof delay === "number" ? delay : 200;
      if (this.calcSumTimer) {
        clearTimeout(this.calcSumTimer);
      }
      this.calcSumTimer = setTimeout(() => {
        this.calcSumTimer = null;
        this.calcSum();
      }, wait);
    },
    // bugfix //timing render invoice each row — shared product autocomplete
    warmSharedProductAutocomplete() {
      if (!this.id || this.sharedProductEdit.warmed) return;
      this.sharedProductEdit.warmed = true;
    },
    resetSharedProductEdit() {
      this.unbindSharedProductListeners();
      this.sharedProductEdit.active = false;
      this.sharedProductEdit.loading = false;
      this.sharedProductEdit.loadingIndex = null;
      this.sharedProductEdit.item = null;
      this.sharedProductEdit.index = null;
      this.sharedProductEdit.style = null;
      this.sharedProductEdit.warmed = false;
    },
    bindSharedProductListeners() {
      if (this.sharedProductEdit.listenersBound) return;
      this.sharedProductEdit.listenersBound = true;
      document.addEventListener("mousedown", this.onSharedProductDocPointerDown, true);
      window.addEventListener("scroll", this.closeSharedProductEdit, true);
      window.addEventListener("resize", this.closeSharedProductEdit);
    },
    unbindSharedProductListeners() {
      if (!this.sharedProductEdit.listenersBound) return;
      this.sharedProductEdit.listenersBound = false;
      document.removeEventListener("mousedown", this.onSharedProductDocPointerDown, true);
      window.removeEventListener("scroll", this.closeSharedProductEdit, true);
      window.removeEventListener("resize", this.closeSharedProductEdit);
    },
    onSharedProductDocPointerDown(e) {
      if (!this.sharedProductEdit.active) return;
      const host = this.$refs.sharedProductAutocompleteHost;
      if (host && host.contains(e.target)) return;
      if (
        e.target &&
        e.target.closest &&
        e.target.closest(".product-autocomplete-placeholder")
      ) {
        return;
      }
      if (
        e.target &&
        e.target.closest &&
        (e.target.closest(".v-menu__content") ||
          e.target.closest(".v-dialog") ||
          e.target.closest(".v-overlay"))
      ) {
        return;
      }
      this.closeSharedProductEdit();
    },
    closeSharedProductEdit() {
      if (!this.sharedProductEdit.active && !this.sharedProductEdit.loading) return;
      this.sharedProductEdit.active = false;
      this.sharedProductEdit.loading = false;
      this.sharedProductEdit.loadingIndex = null;
      this.sharedProductEdit.style = null;
      this.unbindSharedProductListeners();
    },
    activateSharedProductEdit({ item, index, el, action }) {
      if (!this.id || !item) return;
      const nextAction = action || "open";

      const placeAndFocus = () => {
        const targetEl =
          el ||
          (typeof document !== "undefined" &&
            document.querySelector(
              `.invoice-table-row:nth-child(${
                index + 1
              }) .product-autocomplete-placeholder`
            ));
        if (!targetEl || !targetEl.getBoundingClientRect) return;
        const rect = targetEl.getBoundingClientRect();
        this.sharedProductEdit.item = item;
        this.sharedProductEdit.index = index;
        this.sharedProductEdit.style = {
          top: rect.top + "px",
          left: rect.left + "px",
          width: rect.width + "px",
          height: Math.max(rect.height, 32) + "px",
        };
        this.sharedProductEdit.active = true;
        this.sharedProductEdit.loading = false;
        this.sharedProductEdit.loadingIndex = null;
        this.bindSharedProductListeners();
        this.$nextTick(() => {
          this.focusSharedProductAutocomplete();
          this.runSharedProductAction(nextAction);
        });
      };

      if (!this.sharedProductEdit.warmed) {
        this.sharedProductEdit.loading = true;
        this.sharedProductEdit.loadingIndex = index;
        this.sharedProductEdit.warmed = true;
        this.$nextTick(() => {
          const start = () => {
            setTimeout(placeAndFocus, 50);
          };
          if (typeof requestAnimationFrame === "function") {
            requestAnimationFrame(() => requestAnimationFrame(start));
          } else {
            start();
          }
        });
        return;
      }

      placeAndFocus();
    },
    getSharedProductAutocompleteRef() {
      const ref = this.$refs.sharedProductAutocomplete;
      return Array.isArray(ref) ? ref[0] : ref;
    },
    focusSharedProductAutocomplete() {
      const autocompleteRef = this.getSharedProductAutocompleteRef();
      if (!autocompleteRef) return;
      const input =
        autocompleteRef.$refs &&
        autocompleteRef.$refs.autocomplete &&
        autocompleteRef.$refs.autocomplete.$refs &&
        autocompleteRef.$refs.autocomplete.$refs.input;
      if (input && typeof input.focus === "function") {
        input.focus();
      } else if (autocompleteRef.$el) {
        const el = autocompleteRef.$el.querySelector("input");
        if (el) el.focus();
      }
    },
    runSharedProductAction(action) {
      if (!action || action === "open") return;
      const autocompleteRef = this.getSharedProductAutocompleteRef();
      if (!autocompleteRef) return;
      if (action === "new" && typeof autocompleteRef.openProductDialog === "function") {
        autocompleteRef.openProductDialog();
        return;
      }
      if (
        action === "barcode" &&
        typeof autocompleteRef.openBarcodeDialog === "function"
      ) {
        autocompleteRef.openBarcodeDialog();
      }
    },
    onSharedProductInput(val) {
      const item = this.sharedProductEdit.item;
      const index = this.sharedProductEdit.index;
      if (!item) return;
      item.product = val;
      this.changeProduct(item, index);
    },
    onSharedProductClear() {
      const item = this.sharedProductEdit.item;
      if (!item) return;
      this.clearRow(item);
    },
    // update price function
    updatePrice() {
      if (this.comeFromCopy || !this.watcher) return;
      if (!this.currency || !this.currency.id) return;
      if (!this.branch || !this.branch.id) return;
      if (!Array.isArray(this.items) || !this.items.length) return;
      if (this.priceType !== "formulaPrice") return;
      // if (this.id || this.$route.params.id) return;
      if (
        !(this.type === "sell" || this.type === "presale" || this.type === "returnSell")
      )
        return;
      this.items.forEach((item, index) => {
        if (item && item.product && item.product.id) {
          setTimeout(() => {
            if (!this.resolveFormulaFee(item)) {
              this.getPrice(item);
            }
          }, index * 600);
        }
      });
    },
    fetchUserCredit() {
      var app = this;
      app.isLoading = true;
      app.$axios
        .post(app.$apipoint + "config/customer-club/dobare/current-credit", {
          user_id: this.userId,
        })
        .then((r) => {
          this.userCredit = r.data.data.customer_club_credit;
          app.isLoading = false;
        })
        .catch((err) => {
          app.serverErrorHandeler(err);
        })
        .finally(() => (app.isLoading = false));
    },
    openPosDialog(type, selectedItem) {
      this.addNewPosDialog = true;
      this.getPosesListBySocket();
      if (type == "add") {
        this.dialogType = "add";
        /* if (this.posItems.length > 0) { */
        this.clearPosForm();
        /* }   */
      }
      if (type == "edit" && selectedItem != null) {
        this.dialogType = "edit";
        this.newPos = {
          title: selectedItem.title,
          posDevice: selectedItem.posDevice,
          posIp: selectedItem.posIp,
          posPort: selectedItem.posPort,
          bank: selectedItem.bank,
          status: selectedItem.status,
        };
        this.selectedIndex = this.posItems.findIndex(
          (item) =>
            item.title == selectedItem.title &&
            item.posIp == selectedItem.posIp &&
            item.posPort == selectedItem.posPort
        );
      }
    },
    checkValidation() {
      if (this.$refs.posForm.validate() && this.dialogType == "add") {
        this.addPosRecord();
      }
      if (this.$refs.posForm.validate() && this.dialogType == "edit") {
        this.editPosRecord();
      }
    },
    addPosRecord() {
      this.posItems.push(this.newPos);
      this.posItems.forEach((item, index) => {
        item.status = index === 0 ? "active" : "deactive";
      });
      this.isPosActive = this.posItems[0].status === "active";
      this.addNewPosDialog = false;
      localStorage.setItem("posDevice", JSON.stringify(this.posItems));
    },
    editPosRecord() {
      this.posItems.splice(this.selectedIndex, 1, this.newPos);
      this.addNewPosDialog = false;
      localStorage.setItem("posDevice", JSON.stringify(this.posItems));
    },
    clearPosForm() {
      this.newPos = {
        title: null,
        posDevice: null,
        posIp: null,
        posPort: null,
        bank: null,
        status: null,
      };
      // reset form
      if (this.$refs.posForm) {
        this.$refs.posForm.reset();
      }
    },
    setActiveStatus(selectedIndex) {
      this.posItems.forEach((item, index) => {
        item.status = index === selectedIndex ? "active" : "deactive";
      });
      this.isPosActive = this.posItems[0].status === "active";
      localStorage.setItem("posDevice", JSON.stringify(this.posItems));
    },
    openDeletePermissionDialog(type, item, index) {
      this.deletePermissionDialog = true;
      if (type == "all") {
        this.isAllItemsDelete = true;
      }
      if (type == "single") {
        this.deletedIndex = index;
      }
    },
    removePosRecord() {
      if (this.isAllItemsDelete) {
        this.posItems = [];
      } else {
        this.posItems.splice(this.deletedIndex, 1);
      }
      localStorage.setItem("posDevice", JSON.stringify(this.posItems));
      this.deletePermissionDialog = false;
    },
    getPosInfo() {
      const socket = new WebSocket("ws://127.0.0.1:8145/Query");
      socket.onopen = () => {
        socket.send(JSON.stringify({ Key: "POS" }));
      };
      socket.onmessage = (event) => {
        const data = JSON.parse(event.data);
        this.POSIP = data.Result.posIp;
        this.POSPORT = data.Result.posPort;
      };
    },
    getPosesListBySocket() {
      const socket = new WebSocket("ws://127.0.0.1:8145/Query");
      socket.onopen = () => {
        socket.send(JSON.stringify({ Key: "POSES" }));
      };
      socket.onmessage = (event) => {
        const data = JSON.parse(event.data);
        this.posesList = data.Result;
      };
    },
    sendToPosProcess(value) {
      if (value != undefined && value != null && value != "remain") {
        this.compositeAmount = value;
      }
      this.items = this.items.filter((item) => !!item.product);
      //1. check items
      if (this.items && this.items.length == 0) {
        this.snakbar = true;
        this.snakbarText = this.$t("first you should add some items");
        this.snakbarColor = "red";
        return;
      }
      //3. check added pos device
      const posDeviceArray = JSON.parse(localStorage.getItem("posDevice"));
      if (
        (posDeviceArray != undefined && posDeviceArray.length == 0) ||
        posDeviceArray == undefined
      ) {
        this.snakbar = true;
        this.snakbarText = this.$t("first in setting below set your pos device.");
        this.snakbarColor = "red";
        return;
      }
      // Wait for empty rows to leave the DOM, then validate and start POS
      this.$nextTick(() => {
        if (!this.$refs.form || !this.$refs.form.validate()) {
          this.notifyFormValidationFailed("red");
          return;
        }
        if (this.items && this.items.length > 0 && posDeviceArray.length > 0) {
          this.setPosIp(posDeviceArray);
        }
      });
    },
    setPosIp(value) {
      const selectedPos = value.find((item) => item.status == "active");
      var selectedPosKey;
      if (selectedPos.posDevice.Key == "EghtesadNovin") {
        selectedPosKey = 0;
      }
      if (selectedPos.posDevice.Key == "Saman") {
        selectedPosKey = 1;
      }
      if (selectedPos.posDevice.Key == "BehPardakht") {
        selectedPosKey = 2;
      }
      const socket = new WebSocket("ws://127.0.0.1:8145/Command");
      socket.onopen = () => {
        const message = {
          Key: 1,
          Data: {
            PosIP: this.POSIP,
            PosPort: this.POSPORT,
            PosType: selectedPosKey,
          },
        };
        socket.send(JSON.stringify(message));
      };
      socket.onmessage = (event) => {
        const data = JSON.parse(event.data);
        if (data == 0) {
          //6. initialize pos device
          this.sendToPos(selectedPosKey);
        } else {
          this.snakbar = true;
          this.snakbarText = this.$t("POSIP did not set correctly.");
          this.snakbarColor = "red";
        }
      };
    },
    sendToPos(selectedPosKey) {
      const socket = new WebSocket("ws://127.0.0.1:8145/Pos");
      this.progressPercent = 0;
      this.isPosSuccessfull = false;
      this.posPending = true;
      this.loadingDialog = true;
      this.lodingText = this.$t("waitingTogetDataFromPOS");

      let interval = setInterval(() => {
        if (this.progressPercent < 100) {
          this.progressPercent += 1;
        } else {
          clearInterval(interval);
        }
      }, 300);

      let state = "init"; // or: 'waitingForResponse'

      const timeout = setTimeout(() => {
        if (!this.isPosSuccessfull && state === "waitingForResponse") {
          clearInterval(interval);
          this.loadingDialog = false;
          this.posPending = false;
          this.snakbar = true;
          this.snakbarText = data.ResponseMessage;
          this.snakbarColor = "red";
        }
      }, 35000);

      socket.onopen = () => {
        const message = {
          Cmd: 0,
          PosType: selectedPosKey,
        };
        socket.send(JSON.stringify(message));
      };

      socket.onmessage = (event) => {
        const data = JSON.parse(event.data);

        if (state === "init" && data === 0) {
          // Initial response, send transaction
          const message = {
            Cmd: 1,
            PosType: selectedPosKey,
            Amount:
              this.compositeAmount != null
                ? Number(this.compositeAmount)
                : Number(this.remainInvoice),
          };
          socket.send(JSON.stringify(message));
          state = "waitingForResponse";
        } else if (state === "waitingForResponse") {
          if (data?.IsSuccessfull && data.Amount !== "") {
            // Success
            this.snakbar = true;
            this.snakbarText = data.ResponseMessage;
            this.snakbarColor = "green";

            clearInterval(interval);
            clearTimeout(timeout);
            this.progressPercent = 100;
            this.isPosSuccessfull = true;

            this.returnPosInfo = {
              amount: data.Amount,
              date: data.Time,
            };

            this.optionDialogType = null;
            this.$nextTick(() => {
              this.optionDialogType = "pos";
            });

            setTimeout(() => {
              this.loadingDialog = false;
              this.posPending = false;
              this.create();
            }, 4000);
          } else if (data?.IsSuccessfull === false && data.Amount === "") {
            // Canceled or failed early
            clearInterval(interval);
            clearTimeout(timeout);
            this.progressPercent = 0;
            this.isPosSuccessfull = false;
            this.loadingDialog = false;
            this.posPending = false;
            this.snakbar = true;
            this.snakbarText = data.ResponseMessage;
            this.snakbarColor = "red";

            if (data.ResponseMessage == "پاسخ تعریف نشده") {
              this.snakbar = true;
              this.snakbarText = this.$t(
                "connection to the socket has problem please try again."
              );
              this.snakbarColor = "red";
            }
          }
          if (this.compositeAmount != null) {
            this.compositeAmount = null;
          }
        } else {
          // Connection failed or unexpected message
          clearInterval(interval);
          clearTimeout(timeout);
          this.progressPercent = 0;
          this.snakbar = true;
          this.snakbarText = this.$t("connection to pos Device didn't create");
          this.snakbarColor = "red";
          this.loadingDialog = false;
        }
      };
    },
    openGoldDialog(item) {
      this.itemDialog = item;
      this.taxStatus = "active";
      this.goldDialog = true;
    },
    calGoldDialog() {
      if (this.itemDialog) {
        this.calConstructionWages();
        this.calProfit();
        this.calCommission();
      }
    },
    calConstructionWages() {
      if (this.itemDialog.construction_wages_percent === undefined) {
        this.itemDialog.construction_wages_percent = 0;
      }
      var cutie =
        (this.itemDialog.cutie && this.itemDialog.cutie > 0
          ? this.itemDialog.cutie
          : 750) / 750;
      var value = Math.trunc(
        cutie.toFixed(2) * this.itemDialog.count * this.itemDialog.fee -
          +this.itemDialog.discount
      );
      this.itemDialog.construction_wages = Math.trunc(
        value * (this.itemDialog.construction_wages_percent / 100)
      );
    },
    calProfit() {
      if (this.itemDialog.profit_percent === undefined) {
        this.itemDialog.profit_percent = 0;
      }
      var cutie =
        (this.itemDialog.cutie && this.itemDialog.cutie > 0
          ? this.itemDialog.cutie
          : 750) / 750;
      var value = Math.trunc(
        cutie.toFixed(2) * this.itemDialog.count * this.itemDialog.fee -
          +this.itemDialog.discount +
          +this.itemDialog.construction_wages
      );
      this.itemDialog.profit = Math.trunc(value * (this.itemDialog.profit_percent / 100));
    },
    calCommission() {
      if (this.itemDialog.commission_percent === undefined) {
        this.itemDialog.commission_percent = 0;
      }
      var cutie =
        (this.itemDialog.cutie && this.itemDialog.cutie > 0
          ? this.itemDialog.cutie
          : 750) / 750;
      var value = Math.trunc(
        cutie.toFixed(2) * this.itemDialog.count * this.itemDialog.fee -
          +this.itemDialog.discount
      );
      this.itemDialog.commission = Math.trunc(
        value * (this.itemDialog.commission_percent / 100)
      );
    },
    changeEntrepotAtRow(item, index) {
      if (!this.watcher) {
        return false;
      }
      if (!item.product || !item.article_entrepot) {
        return false;
      }
      var app = this;
      app.isLoading = true;
      app.$axios
        .get(app.$endpoint + "getdetail", {
          params: {
            select: "getProductStock",
            id: item.product.id,
            entrepotId: item.article_entrepot.id,
          },
        })
        .then((res) => {
          res = res.data;
          if (item.product.stock.count > res) {
            item.count = 0;
            app.snakbarText = app.$t("alert-is-not-enough-inventory");
            app.snakbarColor = "pink";
            app.snakbar = true;
          }
          item.product.stock.count = res;
        })
        .catch((err) => {
          app.serverErrorHandeler(err);
        })
        .finally(() => (app.isLoading = false));
    },
    unitCalc(item) {
      if (item.product && item.unit) {
        var i = item.product.units.findIndex((x) => x.unit_id === item.unit.id);
        if (i !== -1 && item.product.units[i].value) {
          return +item.product.units[i].value;
        } else {
          return 1;
        }
      }
    },
    unitItems(item) {
      if (item.product) {
        var units = [item.product.unit];
        if (item.product.units && item.product.units.length > 0) {
          item.product.units.map(function (value, index) {
            value.unit.value = value.value;
            units.push(value.unit);
          });
        }
        if (!item.unit) {
          item.unit = item.product.unit;
        }
        return units;
      } else {
        return [];
      }
    },
    onResize() {
      var height = 515;
      if (window.innerHeight < 650) {
        height = 415;
      }
      this.tableHeightInvoice = this.isMobile
        ? window.innerHeight - height
        : window.innerHeight - height;
    },
    resolveSubmitBtnHeight() {
      if (this.$vuetify.breakpoint.width <= 1137) {
        return 34;
      }
      return 36;
    },
    beforeMount() {
      if (this.accountProp) {
        this.account = this.accountProp;
      }
      if (this.$route.name === "Sell") {
        this.type = "sell";
      }
      if (this.$route.name === "presale") {
        this.type = "presale";
      }
      if (this.$route.name === "purchase") {
        this.type = "purchase";
        this.number = 1;
      }
      if (this.$route.name === "returnPurchase") {
        this.type = "returnPurchase";
        this.number = 1;
      }
      if (this.$route.name === "returnSell") {
        this.type = "returnSell";
      }
      if (this.$route.params.id != null) {
        this.show();
        this.id = this.$route.params.id;
        this.render = false;
      } else {
        this.defaultCurrency = this.getDefault("defaultCurrency");
        this.currency = this.$store.state.currency;
        this.getInvoiceNumber();
        if (this.items && this.items.length === 0) {
          this.addRow();
          this.watcher = true;
        }
      }
      if (this.$store.state.currency && !this.id && !this.account) {
        this.currency = this.$store.state.currency;
        this.currency_amount = this.$store.state.currency.amount;
      }
      if (this.itemsProp) {
        this.items = this.itemsProp;
        this.comeFromCopy = true;
        this.watcher = false;
        (this.items || []).forEach((item) => {
          item._boundProductId = item.product ? item.product.id : null;
          if (!item._uid) {
            item._uid = `copy-${item.id || Math.random().toString(36).slice(2)}`;
          }
        });
        if (this.metaProp) {
          this.account = this.metaProp.customer || null;
          this.branch = this.metaProp.branch || this.branch;
          this.date = this.metaProp.date || null;
          this.entrepot = this.metaProp.entrepot || null;
        }
        this.$nextTick(() => {
          this.calcSum();
          setTimeout(() => {
            this.watcher = true;
            this.comeFromCopy = false;
          }, 3000);
        });
      } else {
        if (!this.account && !this.id) {
          this.items = [];
          this.watcher = true;
          this.addRow();
        }
      }
    },
    checkProductsCount() {
      var app = this;
      if (this.items && this.items.length > 0) {
        this.items.map(function (value, index) {
          // value.product = null
          if (app.$refs["refProduct" + index] !== undefined) {
            // app.$refs['refProduct' + index].clear()
          }
        });
      }
    },
    zeroCountCheck(item) {
      if (parseFloat(item.count) === 0) {
        item.count = 1;
        this.checkCount(item);
      }
    },
    discountChangeStatus() {
      this.percentDiscountStatus = !this.percentDiscountStatus;
      this.taxStatus = false;
    },
    discountCheck() {
      this.discount = 0;
      this.totalDiscount = 0;
      if (Number(this.discountPercent) > 100) {
        this.discountPercent = 100;
      }
      if (Number(this.discountPercent) < 0) {
        this.discountPercent = 0;
      }
      if (this.total > 0) {
        var discount = this.total * (this.discountPercent / 100);
        this.discount = discount.toFixed(this.decimal);
        this.checkTotalDiscount();
      }
    },
    openDiscountModeDialog() {
      this.captureHeaderDiscountSnapshot();
      this.pendingHeaderDiscount = this.parseHeaderDiscountAmount(this.discount);
      if (
        (!this.pendingHeaderDiscount || this.pendingHeaderDiscount <= 0) &&
        !this.totalDiscountType
      ) {
        let sum = 0;
        (this.items || []).forEach((row) => {
          sum += parseFloat(row.discount) || 0;
        });
        if (sum > 0) {
          this.pendingHeaderDiscount = sum;
          this.discount = sum;
        }
      }
      this._headerDiscountModeSubmitted = false;
      this.discountModeDialog = true;
    },
    clampHeaderDiscountPercent() {
      if (Number(this.discountPercent) > 100) {
        this.discountPercent = 100;
      }
      if (Number(this.discountPercent) < 0) {
        this.discountPercent = 0;
      }
    },
    resolveHeaderDiscountFromPercent() {
      this.clampHeaderDiscountPercent();
      let baseTotal = 0;
      (this.items || []).forEach((row) => {
        if (!row || !row.product) {
          return;
        }
        baseTotal += parseFloat(row.fee || 0) * parseFloat(row.count || 0);
      });
      const pct = Number(this.discountPercent) || 0;
      this.discount = parseFloat((baseTotal * (pct / 100)).toFixed(this.decimal));
    },
    onHeaderDiscountPercentInput() {
      this.resolveHeaderDiscountFromPercent();
    },
    onHeaderDiscountPercentBlur() {
      this.resolveHeaderDiscountFromPercent();
      this.onHeaderDiscountBlur();
    },
    captureHeaderDiscountSnapshot() {
      this.snapshotHeaderDiscount = this.discount;
      this.snapshotHeaderDiscountPercent = this.discountPercent;
    },
    resolveHeaderDiscountSnapshot() {
      if (
        this.snapshotHeaderDiscount !== null &&
        this.snapshotHeaderDiscount !== undefined
      ) {
        return this.snapshotHeaderDiscount;
      }
      if (!this.totalDiscountType) {
        let sum = 0;
        (this.items || []).forEach((row) => {
          sum += parseFloat(row.discount) || 0;
        });
        return sum;
      }
      return this.discount;
    },
    restoreHeaderDiscountToSnapshot() {
      const restored = this.resolveHeaderDiscountSnapshot();
      if (restored === null || restored === undefined) {
        return;
      }
      this.snapshotHeaderDiscount = restored;
      this.discount = restored;
      if (
        this.snapshotHeaderDiscountPercent !== null &&
        this.snapshotHeaderDiscountPercent !== undefined
      ) {
        this.discountPercent = this.snapshotHeaderDiscountPercent;
      }
      if (this.totalDiscountType) {
        this.totalDiscount = this.parseHeaderDiscountAmount(restored);
      } else {
        this.totalDiscount = 0;
      }
      this.headerDiscountInputKey += 1;
      this.$nextTick(() => {
        this.discount = restored;
        this.calcSum();
      });
    },
    onHeaderDiscountFocus() {
      this.captureHeaderDiscountSnapshot();
    },
    onHeaderDiscountInput(value) {
      this.discount = value;
    },
    onHeaderDiscountBlur() {
      if (this.discountModeDialog) {
        return;
      }
      const current = this.parseHeaderDiscountAmount(this.discount);
      const previous = this.parseHeaderDiscountAmount(
        this.resolveHeaderDiscountSnapshot()
      );
      if (current === previous) {
        return;
      }
      this.snapshotHeaderDiscount = this.resolveHeaderDiscountSnapshot();
      this.pendingHeaderDiscount = current;
      this._headerDiscountModeSubmitted = false;
      this.discountModeDialog = true;
    },
    parseHeaderDiscountAmount(value) {
      if (value === null || value === undefined || value === "") {
        return 0;
      }
      return parseFloat(String(value).replace(/,/g, "")) || 0;
    },
    distributeHeaderDiscountByRowWeight(totalDiscount) {
      this.applyHeaderDiscountByRowWeight(totalDiscount, false);
    },
    appendHeaderDiscountByRowWeight(totalDiscount) {
      this.applyHeaderDiscountByRowWeight(totalDiscount, true);
    },
    applyHeaderDiscountByRowWeight(totalDiscount, addToExisting) {
      const decimal = this.decimal;
      const rows = (this.items || []).filter((row) => row && row.product);
      let baseTotal = 0;
      rows.forEach((row) => {
        baseTotal += parseFloat(row.fee || 0) * parseFloat(row.count || 0);
      });
      if (baseTotal <= 0) {
        return;
      }
      const total = this.parseHeaderDiscountAmount(totalDiscount);
      if (total <= 0) {
        return;
      }
      let assigned = 0;
      rows.forEach((row, index) => {
        const rowBase = parseFloat(row.fee || 0) * parseFloat(row.count || 0);
        if (rowBase <= 0) {
          return;
        }
        let share;
        if (index === rows.length - 1) {
          share = parseFloat((total - assigned).toFixed(decimal));
        } else {
          share = parseFloat((total * (rowBase / baseTotal)).toFixed(decimal));
          assigned += share;
        }
        const existing = addToExisting ? parseFloat(row.discount) || 0 : 0;
        let disc = existing + share;
        disc = Math.min(rowBase, Math.max(0, disc));
        const pct = rowBase > 0 ? parseFloat(((disc / rowBase) * 100).toFixed(2)) : 0;
        this.$set(row, "discount", disc);
        this.$set(row, "discountPercent", pct);
        this.$set(row, "discountMode", "amount");
      });
      let sumRows = 0;
      rows.forEach((row) => {
        sumRows += parseFloat(row.discount) || 0;
      });
      this.discount = parseFloat(sumRows.toFixed(decimal));
      // Keep header totalDiscount at 0 so `total = sum - totalDiscount` does not double-subtract
      // after row discounts are already applied inside calcSum.
      this.totalDiscount = 0;
    },
    clearHeaderDistributedRowDiscounts() {
      (this.items || []).forEach((row) => {
        if (!row || !row.product) {
          return;
        }
        this.$set(row, "discount", 0);
        this.$set(row, "discountPercent", 0);
        this.$set(row, "discountMode", "amount");
      });
      this.discount = 0;
      this.totalDiscount = 0;
    },
    onHeaderDiscountModeSubmit(mode) {
      this._headerDiscountModeSubmitted = true;
      if (this.pendingHeaderDiscount == null) {
        return;
      }
      const totalDisc = this.parseHeaderDiscountAmount(this.pendingHeaderDiscount);
      this.discount = totalDisc;
      if (totalDisc <= 0) {
        this.clearHeaderDistributedRowDiscounts();
      } else if (mode === "append") {
        this.appendHeaderDiscountByRowWeight(totalDisc);
      } else {
        this.distributeHeaderDiscountByRowWeight(totalDisc);
      }
      this.totalDiscountType = false;
      this.totalDiscount = 0;
      this._vaznDistributeJustApplied = true;
      this.calcSum();
      this._vaznDistributeJustApplied = false;
      this.pendingHeaderDiscount = null;
      this.snapshotHeaderDiscount = null;
      this.snapshotHeaderDiscountPercent = null;
      this.headerDiscountInputKey += 1;
    },
    onHeaderDiscountModeCancel() {
      if (this.pendingHeaderDiscount !== null) {
        this.restoreHeaderDiscountToSnapshot();
      }
      this.pendingHeaderDiscount = null;
      this.snapshotHeaderDiscount = null;
      this.snapshotHeaderDiscountPercent = null;
      this._headerDiscountModeSubmitted = false;
    },
    checkBankRemain(sum) {
      var app = this;
      app.validBank = true;
      if (app.type === "purchase" || app.type === "returnSell") {
        if (
          this.clearingStatus &&
          this.bank &&
          sum > parseFloat(this.bank.remain.currency_remain)
        ) {
          app.validBank = true;
          app.snakbarText = this.$t("alert-pay-amount-bigger-than-bank-remain");
          app.snakbarColor = "pink";
          app.snakbar = true;
        }
      }
    },
    getInvoiceNumber() {
      if (this.type === "returnPurchase" || this.type === "purchase") {
        return false;
      }
      this.loading = true;
      var app = this;
      app.isLoading = true;
      clearTimeout(this.timer);
      this.timer = setTimeout(function () {
        app.$axios
          .get(app.$endpoint + "getdetail", {
            params: {
              type: app.type,
              id: app.id,
              number: app.number,
              select: "getInvoiceNumber",
            },
          })
          .then((res) => {
            res = res.data;
            if (res.status === "error") {
              if (app.checkNumber) {
                app.snakbarText = res.message;
                app.snakbarColor = "pink";
                app.snakbar = true;
              }
              app.number = res.number;
            }
            if (res.status === "success") {
              app.number = res.number;
            }
            app.checkNumber = true;
          })
          .catch((err) => {
            this.serverErrorHandeler(err);
          })
          .finally(() => (app.isLoading = false));
      }, 50);
      // setTimeout(() => {
      //   app.$refs.autocomplete.onScroll()
      // }, 1500)
      this.loading = false;
    },
    getOfficialInvoiceNumber() {
      if (this.type === "returnPurchase" || this.type === "purchase") {
        return false;
      }
      this.loading = true;
      var app = this;
      app.isLoading = true;
      clearTimeout(this.timer);
      this.timer = setTimeout(function () {
        app.$axios
          .get(app.$endpoint + "getdetail", {
            params: {
              type: app.type,
              id: app.id,
              number: app.officialNumber,
              select: "getOfficialInvoiceNumber",
            },
          })
          .then((res) => {
            res = res.data;
            if (res.status === "error") {
              if (app.checkOfficialNumber) {
                app.snakbarText = res.message;
                app.snakbarColor = "pink";
                app.snakbar = true;
              }
              app.officialNumber = res.number;
            }
            app.checkOfficialNumber = true;
          })
          .catch((err) => {
            this.serverErrorHandeler(err);
          })
          .finally(() => (app.isLoading = false));
      }, 50);
      // setTimeout(() => {
      //   app.$refs.autocomplete.onScroll()
      // }, 1500)
      this.loading = false;
    },
    samePricingId(a, b) {
      if (a == null && b == null) return true;
      if (a == null || b == null) return false;
      return String(a) === String(b);
    },
    resolveFormulaFee(item) {
      if (this.priceType !== "formulaPrice" || !item?.product) return false;
      if (!item.product.pricing?.length) return false;
      return this.applyPricingToRow(
        item,
        this.branch,
        this.currency,
        this.account,
        this.totalDiscountType
      );
    },
    findMatchedPricingRule(product, count, branch, currency, categoryId, ruleType) {
      const pricing = product?.pricing;
      if (!pricing || pricing.length === 0) {
        return null;
      }
      const branchId = branch?.id ?? null;
      const currencyId = currency?.id ?? null;
      const accountCategoryId = categoryId ?? null;
      const qty = parseFloat(count || 0);
      const findRule = (targetCategoryId) =>
        pricing.find((rule) => {
          if (rule.type !== ruleType) {
            return false;
          }
          const ruleCategoryId = rule.category_id ?? rule.category?.id ?? null;
          if (!this.samePricingId(ruleCategoryId, targetCategoryId)) {
            return false;
          }
          const ruleBranchId = rule.branch_id ?? rule.branch?.id ?? null;
          if (ruleBranchId != null && !this.samePricingId(ruleBranchId, branchId)) {
            return false;
          }
          const ruleCurrencyId = rule.currency_id ?? rule.currency?.id ?? null;
          if (
            ruleCurrencyId != null &&
            currencyId != null &&
            !this.samePricingId(ruleCurrencyId, currencyId)
          ) {
            return false;
          }
          const min =
            rule.min != null && rule.min !== "" ? parseFloat(rule.min) : -Infinity;
          const max =
            rule.max != null && rule.max !== "" ? parseFloat(rule.max) : Infinity;
          return qty >= min && qty <= max;
        }) || null;

      return accountCategoryId != null
        ? findRule(accountCategoryId) || findRule(null)
        : findRule(null);
    },
    applyPricingToRow(item, branch, currency, account, totalDiscountType = false) {
      if (!item?.product) {
        return false;
      }
      const product = item.product;
      const categoryId = account?.category_id ?? null;
      const count = parseFloat(item.count || 0);
      const priceRule = this.findMatchedPricingRule(
        product,
        item.count,
        branch,
        currency,
        categoryId,
        "price"
      );
      if (!priceRule || priceRule.price == null) {
        return false;
      }
      item.fee = parseFloat(priceRule.price);
      const productDiscPct = parseFloat(product.discount_percent || 0);
      if (productDiscPct > 0 && !totalDiscountType) {
        const rowMax = item.fee * count;
        item.discountPercent = productDiscPct;
        item.discount = parseFloat(
          (rowMax * (productDiscPct / 100)).toFixed(this.decimal)
        );
      } else {
        item.discount = 0;
        item.discountPercent = 0;
      }
      const discountRule = !totalDiscountType
        ? this.findMatchedPricingRule(
            product,
            item.count,
            branch,
            currency,
            categoryId,
            "discount"
          )
        : null;
      if (discountRule) {
        const rulePrice = parseFloat(discountRule.price || 0);
        const hasPercent = discountRule.percent != null && discountRule.percent !== "";
        const currentRowMax = parseFloat(item.fee || 0) * count;
        if (hasPercent && rulePrice === 0) {
          const pct = parseFloat(discountRule.percent);
          item.discountPercent = pct;
          item.discount = parseFloat((currentRowMax * (pct / 100)).toFixed(this.decimal));
        } else if (
          (discountRule.percent == null || discountRule.percent === "") &&
          rulePrice > 0
        ) {
          item.discount = Math.min(currentRowMax, rulePrice);
          item.discountPercent =
            currentRowMax > 0
              ? parseFloat(((item.discount / currentRowMax) * 100).toFixed(this.decimal))
              : 0;
        }
      }
      return true;
    },
    checkingProductReturnSellOrPurchus() {
      const isReturnType = this.type === "returnPurchase" || this.type === "returnSell";
      if (!isReturnType) return;
      if (!this.account || !this.account.id) return;
      const productIds = this.items
        .filter((i) => i.product && i.product.id)
        .map((i) => i.product.id);
      if (!productIds.length) return;
      this.$axios
        .get(this.$endpoint + "inquiry/customer-has-invoice-before", {
          params: {
            type: this.type,
            customer_id: this.account.id,
            product_ids: productIds,
          },
        })
        .then((res) => {
          let response = res.data;
          if (response.success == false) {
            this.inquiryMessage = response.message;
            this.inquiryDialog = true;
          }
        })
        .catch((err) => {
          this.serverErrorHandeler(err);
        });
    },
    changeProduct(item, i) {
      const newProductId = item && item.product ? item.product.id : null;
      if (item._boundProductId === newProductId) {
        this.syncRowSerialFlag(item);
        return;
      }
      item._boundProductId = newProductId;
      this.syncRowSerialFlag(item);
      this.checkingProductReturnSellOrPurchus();
      if (!this.isFirstLoad) {
        var count = 0;
        var app = this;
        this.items.map(function (value, index) {
          if (value.product && value.product.id === item.product.id) {
            count++;
          }
          if (count > 1) {
            app.snakbarText = app.$t("thisProductIsRepetitious");
            app.snakbarColor = "pink";
            app.snakbar = true;
            // app.remove(item, i)
            return false;
          }
        });
        if (item.product && item.product.kind_id === 112) {
          item.construction_wages_percent = app.watcher
            ? item.product.construction_wages_percent
            : item.construction_wages_percent;
          item.profit_percent = app.watcher
            ? item.product.profit_percent
            : item.profit_percent;
          item.commission_percent = app.watcher
            ? item.product.commission_percent
            : item.commission_percent;
          item.count = app.watcher ? item.product.weight : item.count;
        }
        if (
          this.type === "sell" ||
          this.type === "returnPurchase" ||
          this.type === "presale"
        ) {
          if (
            !this.deleteItem &&
            this.currency &&
            item.product &&
            item.product.price &&
            this.currency.id === this.$store.state.currency.id
          ) {
            if (!this.itemsProp || this.watcher) {
              item.fee = item.product.price;
            }
            // item.fee = item.product.price;
          } else {
            if (!this.id && !this.itemsProp) {
              // item.fee = 0
            }
          }
          if (
            this.type !== "returnPurchase" &&
            this.currency &&
            item.product &&
            item.product.discount &&
            this.currency.id === this.$store.state.currency.id
          ) {
            item.discount = item.product.discount;
            item.discountPercent = this.itemDiscountPercentCalc(item);
          }
          if (
            this.type !== "returnPurchase" &&
            this.currency &&
            item.product &&
            item.product.discount === null &&
            item.product.discount_percent &&
            this.currency.id === this.$store.state.currency.id
          ) {
            item.discountPercent = item.product.discount_percent;
          }
          // this.calcSum()
        } else {
        }
      } else {
      }
      if (
        (!this.itemsProp || this.watcher) &&
        (!this.id || this.watcher) &&
        !this.comeFromCopy &&
        item.product &&
        (this.type === "sell" ||
          this.type === "presale" ||
          this.type === "returnPurchase")
      ) {
        if (this.priceType !== "formulaPrice" && !item.product.price) {
          if (!(this.itemsProp && parseFloat(item.fee) > 0)) {
            item.fee = 0;
          }
        }
        if (this.priceType === "formulaPrice") {
          if (this.itemsProp && parseFloat(item.fee) > 0) {
            // keep fee from copied article
          } else if (!this.resolveFormulaFee(item)) {
            this.getPrice(item);
          }
        } else if (this.currency && item.product.price) {
          item.fee = item.product.price;
        } else {
          if (!(this.itemsProp && parseFloat(item.fee) > 0)) {
            item.fee = 0;
          }
        }
      } else if (
        this.type === "purchase" &&
        item.product &&
        (!this.itemsProp || this.watcher) &&
        (!this.id || this.watcher) &&
        !this.comeFromCopy
      ) {
        item.fee = item.product.last_purchase_fee;
      }
      if (!item.product) {
        item.unit = null;
      }
      if (this.items[this.items.length - 1] === item) this.addRow();
    },
    clearRow(item) {
      item.unit = null;
      item.fee = 0;
      item.count = 0;
      item.discount = 0;
      item.discountPercent = 0;
      item.tax = 0;
      this.$set(item, "has_serial", "deactive");
      item.serials = [];
      item._serialProductId = null;
      item._boundProductId = null;
    },
    clearRows() {
      this.items.map(function (value, index) {
        value.fee = 0;
        value.count = 0;
        value.discount = 0;
        value.discountPercent = 0;
        value.tax = 0;
      });
    },
    changePercent(val) {
      this.discountPercent = val;
      this.percentDiscountStatus = true;
    },
    append(product) {
      var count = 1;
      var stock = 20000000;
      if (product.type === "product") {
        stock = product.stock ? product.stock.count : 0;
        if (this.type === "sell" || this.type === "returnPurchase") {
          if (!product.stock || product.stock.count <= 0) {
            this.snakbarText = this.$t("alert-is-not-enough-inventory");
            this.snakbarColor = "pink";
            this.snakbar = true;
            return false;
          }
          if (product.stock && product.stock.count < 1) {
            count = parseFloat(product.stock.count);
          }
        }
      }
      var index = -1;
      // if (this.items && this.items.length == 0) {
      //   this.addRow()
      // }
      if (this.items && this.items.length > 0 && !this.items[0].product) {
        this.items.splice(0, 1);
      }
      index = this.items.findIndex((x) =>
        x.product ? x.product.id === product.id : null
      );
      if (index !== -1) {
        if (
          parseFloat(stock) - parseFloat(this.items[index].count) - parseFloat(1) >=
          0
        ) {
          this.items[index].count = parseFloat(this.items[index].count) + parseFloat(1);
          if (this.type === "sell" || this.type === "presale") {
            // if (product && this.priceType === "formulaPrice") {
            //   this.getPrice(this.items[index]);
            // }
            if (product && (!product.price || this.priceType === "formulaPrice")) {
              if (!this.resolveFormulaFee(this.items[index])) {
                this.getPrice(this.items[index]);
              }
            }
            // if (product && !product.price) {
            //   this.getPrice(this.items[index]);
            // }
          }
        }
      } else {
        var price = product.price ? product.price : 0;
        this.addRow(product, count, price);
      }
      var app = this;
      clearTimeout(this.timer);
      this.timer = setTimeout(function () {
        app.calcSum();
      }, 1000);
    },
    getPrice(item) {
      if (!item || !item.product || !item.product.id) return;
      var app = this;
      // per row debounce create uid
      if (!item._uid) {
        item._uid = `row-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
      }
      var key = item._uid;
      if (this.priceTimers[key]) {
        clearTimeout(this.priceTimers[key]);
      }
      if (!this.showProductList) {
        app.isLoading = true;
      }
      this.priceTimers[key] = setTimeout(function () {
        delete app.priceTimers[key];
        app.$axios
          .get(app.$endpoint + "getdetail", {
            params: {
              select: "getPrice",
              currency_id: app.currency.id,
              type: app.type,
              typePrice: app.typePrice,
              count: item.count,
              customer: app.account,
              product_id: item.product.id,
              branch_id: app.branch?.id,
              category_id:
                app.account && app.account.category_id ? app.account.category_id : -1,
            },
          })
          .then((res) => {
            res = res.data;
            if (res.price > 0) {
              item.fee = res.price;
            } else if (!item.fee) {
              item.fee = 0;
            }
            if (item.fee > 0 && item.count > 0) {
              if (res.discount.amount) {
                item.discount = res.discount.amount;
              }
              if (res.discount.percent && parseFloat(res.discount.percent) > 0) {
                var discount =
                  parseFloat(item.fee) *
                  parseFloat(item.count) *
                  (parseFloat(res.discount.percent) / 100);
                item.discount = discount;
              }
            }
            app.calcSum();
          })
          .catch((err) => {
            app.serverErrorHandeler(err);
          })
          .finally(() => (app.isLoading = false));
      }, 500);
      // setTimeout(() => {
      //   app.$refs.autocomplete.onScroll()
      // }, 1500)
      this.loading = false;
    },
    calcSum() {
      this.calGoldDialog();
      var app = this;
      app.totalTax = 0;
      app.totalDiscount = this.discountEdit ? this.discountEdit : 0;
      app.totalCount = 0;
      app.totalFee = 0;
      app.sum = 0;
      var sumDiscount = 0;
      // if (!this.discountPercent) {
      //   this.discount = 0
      // }
      this.items.map(function (value, index) {
        if (
          value.discountPercent &&
          value.discountPercent > 0 &&
          value.discountMode == "percent"
        ) {
          app.checkDiscountPercentPerRow(value);
        }
        if (
          parseFloat(value.count) * parseFloat(value.fee) <
          parseFloat(value.discount)
        ) {
          value.discount = 0;
          app.discount = 0;
          app.totalDiscount = 0;
        }
        if (app.totalDiscountType) {
          value.discount = 0;
          value.tax = 0;
        } else {
          sumDiscount = sumDiscount + parseFloat(value.discount);
          app.calcTax(value);
        }
        var cutie = 1;
        var additionalAmount = 0;
        if (value.product && value.product.kind_id === 112) {
          if (value.cutie) {
            cutie = (value.cutie / 750).toFixed(2);
          }
          additionalAmount =
            +(value.construction_wages ?? 0) +
            +(value.profit ?? 0) +
            +(value.commission ?? 0);
        }
        app.totalFee =
          parseFloat(value.count) * parseFloat(value.fee) * cutie +
          parseFloat(app.totalFee) +
          +additionalAmount;
        app.totalCount = parseFloat(value.count) + parseFloat(app.totalCount);
        app.totalTax = parseFloat(value.tax) + parseFloat(app.totalTax);
        var rowPrice =
          parseFloat(value.fee * value.count * cutie) -
          parseFloat(value.discount === "" || !value.discount ? 0 : value.discount) +
          parseFloat(value.tax) +
          +additionalAmount;
        app.sum = parseFloat(rowPrice) + parseFloat(app.sum);
      });
      app.totalFee = app.totalFee.toFixed(this.decimal);
      app.totalTax = app.totalTax.toFixed(this.decimal);
      if (!app.totalDiscountType) {
        // Keep typed header value until dialog submit/cancel when rows still have no discount.
        if (sumDiscount > 0 || app._vaznDistributeJustApplied) {
          app.discount = sumDiscount;
        }
        // Row discounts are already deducted inside sum; do not also subtract via totalDiscount.
        app.totalDiscount = 0;
      }
      this.discountEdit = 0;
      // this.calGoldDialog()
    },
    checkTotalDiscount() {
      // Mobile / legacy header-discount path (keeps totalDiscountType = true).
      // Desktop uses onHeaderDiscountBlur → HeaderDiscountModeDialog → row distribute.
      this.taxStatus = false;
      this.totalDiscountType = true;
      this.calcSum();
      this.totalDiscount = this.discount;
      if (
        this.percentDiscountStatus === false &&
        parseFloat(this.discount) > parseFloat(this.sum)
      ) {
        this.discount = 0;
        this.totalDiscount = 0;
      }
    },
    calcTax(item) {
      if (this.taxStatus === "active") {
        var taxPercent = this.taxPercent;
        if (item.product && item.product.tax_percent !== null) {
          taxPercent = item.product.tax_percent;
        }
        var tax = 0;
        if (item.product && item.product.kind_id === 112) {
          tax =
            ((+(item.construction_wages ?? 0) +
              +(item.profit ?? 0) +
              +(item.commission ?? 0)) *
              taxPercent) /
            100;
        } else {
          tax =
            ((parseFloat(item.fee * item.count) -
              parseFloat(item.discount === "" || !item.discount ? 0 : item.discount)) *
              taxPercent) /
            100;
        }
        tax = this.roundMath(tax, this.$store.state.currency.decimal);
        item.tax = tax;
        item.tax_percent =
          (tax /
            (parseFloat(item.fee * item.count) -
              parseFloat(item.discount === "" || !item.discount ? 0 : item.discount))) *
          100;
      } else {
        item.tax = 0;
      }
    },
    changeCurrency() {
      this.bankRemain = 0;
      this.currency_amount = this.currency.amount;
      this.options = {
        locale: "en-US",
        prefix: "",
        suffix: this.currency.symbol || this.$store.state.currencySymbol,
        precision: 0,
      };
    },
    addRow(product = null, count = 0, price = 0) {
      this.items.push({
        product: product,
        count: count,
        countEdit: 0,
        fee: price,
        construction_wages: 0,
        construction_wages_percent: 0,
        profit: 0,
        tax_percent: 0,
        profit_percent: 0,
        commission: 0,
        commission_percent: 0,
        discount: 0,
        discountPercent: 0,
        tax: 0,
        cutie: 750,
        unit: null,
        content: null,
        article_entrepot: null,
        expire_date: null,
        serials: [],
        _uid: `row-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
        _boundProductId: product ? product.id : null,
      });
      // if (this.type === "sell" && product && this.priceType === "formulaPrice") {
      if (
        (this.type === "sell" || this.type === "presale") &&
        product &&
        (!product.price || this.priceType === "formulaPrice")
      ) {
        var index = this.items.findIndex((x) => x.product.id === product.id);
        if (!this.resolveFormulaFee(this.items[index])) {
          this.getPrice(this.items[index]);
        }
      }
    },
    remove(item, index) {
      var app = this;
      var i = this.items.indexOf(this.deleteItem);
      this.items.splice(i, 1);
      this.calcSum();
      this.deletDialog = false;
      setTimeout(function () {
        app.deleteItem = null;
      }, 100);
    },
    openDeleteDialog(item) {
      this.deleteItem = item;
      this.deletDialog = true;
    },
    //add serials
    getProductHasSerial(product) {
      if (!product) return false;
      const flag = (product.meta && product.meta.has_serial) || product.has_serial;
      return flag === "active";
    },
    rowHasSerial(item) {
      return !!(
        item &&
        (item.has_serial === "active" || this.getProductHasSerial(item.product))
      );
    },
    syncRowSerialFlag(item) {
      if (!item) return;
      const productId = item.product && item.product.id;
      if (this.getProductHasSerial(item.product)) {
        this.$set(item, "has_serial", "active");
        item._serialProductId = productId;
        return;
      }
      if (productId && productId === item._serialProductId) return;
      this.$set(item, "has_serial", "deactive");
      item.serials = [];
      item._serialProductId = productId || null;
    },
    normalizeArticleSerials(source) {
      return (source || [])
        .map((serial, index) => {
          const raw =
            typeof serial === "string"
              ? serial
              : serial &&
                (serial.value ||
                  serial.serial ||
                  serial.serial_number ||
                  serial.code ||
                  "");
          const value = String(raw || "").trim();
          if (!value) return null;
          return {
            id: (serial && (serial.id || serial.serial_id)) || null,
            uid: (serial && (serial.uid || serial.id)) || `${value}-${index}`,
            value,
            created_at: (serial && (serial.created_at || serial.createdAt)) || "",
            selected: serial && serial.selected !== undefined ? !!serial.selected : true,
          };
        })
        .filter(Boolean);
    },
    hydrateItemSerials(item) {
      if (!item || !item.product) return;
      if (this.getProductHasSerial(item.product)) {
        this.$set(item, "has_serial", "active");
        item._serialProductId = item.product.id;
      }
      if (item.serials && item.serials.length) return;

      this.$set(item, "serials", this.normalizeArticleSerials(item.product.serials));
    },
    openSerialDialog(item) {
      this.hydrateItemSerials(item);
      if (!item.serials) item.serials = [];
      this.serialItem = item;
      this.serialDialog = true;
      if (this.serialFlow === "out") {
        this.serialPage = 1;
        this.serialLastPage = 1;
        this.serialSearch = "";
        this.$set(item, "serialOptions", []);
        this.fetchProductSerials(item, { page: 1, search: "", append: false });
      }
    },
    onSerialSearch(search) {
      if (!this.serialItem || this.serialFlow !== "out") return;
      this.serialSearch = search || "";
      this.serialPage = 1;
      this.fetchProductSerials(this.serialItem, {
        page: 1,
        search: this.serialSearch,
        append: false,
      });
    },
    loadMoreSerials() {
      if (
        !this.serialItem ||
        this.serialFlow !== "out" ||
        this.serialsLoading ||
        this.serialPage >= this.serialLastPage
      ) {
        return;
      }
      this.fetchProductSerials(this.serialItem, {
        page: this.serialPage + 1,
        search: this.serialSearch,
        append: true,
      });
    },
    mergeSerialOptions(existing, incoming) {
      const next = Array.isArray(existing) ? existing.slice() : [];
      const seen = new Set(next.map((serial) => serial.id).filter((id) => id != null));
      incoming.forEach((serial) => {
        if (serial.id != null && seen.has(serial.id)) return;
        if (serial.id != null) seen.add(serial.id);
        next.push(serial);
      });
      return next;
    },
    selectedSerialRows(item) {
      return this.normalizeArticleSerials(item && item.serials).map((serial) => ({
        ...serial,
        selected: true,
      }));
    },
    fetchProductSerials(item, options = {}) {
      if (!item || !item.product || !item.product.id) {
        this.serialsLoading = false;
        return;
      }
      const page = options.page || 1;
      const search = options.search !== undefined ? options.search : this.serialSearch;
      const append = !!options.append;
      if (append && this.serialsLoading) return;
      const entrepotId = (item.article_entrepot || this.entrepot || {}).id;
      var app = this;
      if (app.serialCancelToken) {
        app.serialCancelToken.cancel("Canceled due to new serial request");
      }
      app.serialCancelToken = app.$axios.CancelToken.source();
      const requestId = ++app.serialRequestId;
      app.serialsLoading = true;
      app.$axios
        .get(app.$endpoint + "getdetail", {
          params: {
            select: "getProductSerials",
            product_id: item.product.id,
            entrepot_id: entrepotId,
            search: search || "",
            page,
          },
          cancelToken: app.serialCancelToken.token,
        })
        .then((res) => {
          if (requestId !== app.serialRequestId || app.serialItem !== item) return;
          const payload = res.data;
          const list = Array.isArray(payload) ? payload : (payload && payload.data) || [];
          app.serialPage =
            (payload &&
              (payload.current_page || (payload.meta && payload.meta.current_page))) ||
            page;
          app.serialLastPage =
            (payload &&
              (payload.last_page || (payload.meta && payload.meta.last_page))) ||
            1;
          const selectedIds = new Set(
            (item.serials || []).map((serial) => serial.id).filter((id) => id != null)
          );
          const selectedValues = new Set(
            (item.serials || []).map((serial) => String(serial.value || "").trim())
          );
          const optionsList = app.normalizeArticleSerials(list).map((serial) => ({
            ...serial,
            selected:
              selectedIds.has(serial.id) ||
              selectedValues.has(String(serial.value || "").trim()),
          }));

          const merged = append
            ? app.mergeSerialOptions(item.serialOptions, optionsList)
            : app.mergeSerialOptions(app.selectedSerialRows(item), optionsList);
          app.$set(item, "serialOptions", merged);
        })
        .catch((err) => {
          if (!app.$axios.isCancel(err)) {
            app.serverErrorHandeler(err);
          }
        })
        .finally(() => {
          if (requestId === app.serialRequestId) {
            app.serialsLoading = false;
          }
        });
    },
    setSerials(serials) {
      if (!this.serialItem) return;
      this.$set(this.serialItem, "serials", serials);
      if (this.serialFlow === "out" && this.serialItem.serialOptions) {
        const selectedIds = new Set(
          (serials || []).map((serial) => serial.id).filter((id) => id != null)
        );
        this.serialItem.serialOptions.forEach((option) => {
          option.selected = selectedIds.has(option.id);
        });
      }
    },
    //
    openTaskDialog(item) {
      this.refId = item.rel_id;
      this.taskId = item.id;
      this.taskDialog = true;
    },
    isEnabled(slot) {
      return this.enabled === slot;
    },
    edit(item) {
      this.$router.push({ name: "ProductEdit", params: { id: item.id } });
    },
    getItems() {
      var app = this;
      app.loading = true;
      app.$axios
        .get(this.$endpoint + "products", {
          params: {
            search: app.search,
            page: app.tableOptions.page,
            refId: app.refId,
            type: app.type,
            sortBy: app.sortBy,
            status: app.productStatus,
            options: app.tableOptions,
            tag: app.tag,
            typeForm: app.typeForm,
          },
        })
        .then((res) => {
          res = res.data;
          app.items = res.data;
          app.totalItems = res.total;
          app.from = res.from;
        })
        .catch((err) => {
          this.serverErrorHandeler(err);
        })
        .finally(() => (app.loading = false));
    },
    checkProduct(item, key) {
      if (item) {
        var index = this.items.findIndex((x) => x.product.id === item.id);
        if (index !== key) {
          this.$refs["refProduct" + key].clear();
          this.snakbarText = this.$t("alert-product-is-repetitive");
          this.snakbarColor = "pink";
          this.snakbar = true;
        }
      }
    },
    getInvoiceFilePicker() {
      if (this.$refs.refFilePicker) return this.$refs.refFilePicker;
      const mobile = this.$refs.invoiceMobile;
      if (mobile && mobile.$refs && mobile.$refs.refFilePicker) {
        return mobile.$refs.refFilePicker;
      }
      return null;
    },
    refreshInvoiceFormTabsSlider() {
      this.$nextTick(() => {
        const tabs = this.$refs.invoiceFormTabs;
        if (tabs && typeof tabs.callSlider === "function") {
          tabs.callSlider();
        }
      });
    },
    calcCommissionAmount() {
      var amount = (parseFloat(this.total) * (this.commissionPercent / 100)).toFixed(
        this.decimal
      );
      this.commissionAmount = amount;
    },
    calcCommissionPercent(item) {
      var percent = (parseFloat(this.commissionAmount) / parseFloat(this.total)) * 100;
      this.commissionPercent = percent;
    },
    checkDiscount(item) {
      item.discountMode = "amount";
      this.totalDiscountType = false;
      this.totalDiscount = 0;
      this.discount = 0;
      if (parseFloat(item.discount) > parseFloat(item.fee * item.count)) {
        item.discount = 0;
      }
      item.discountPercent = this.itemDiscountPercentCalc(item);
      this.calcSum();
    },
    checkDiscountPercent(item) {
      item.discountMode = "percent";
      this.totalDiscountType = false;
      this.totalDiscount = 0;
      this.discount = 0;
      item.discount = (
        parseFloat(item.fee * item.count) *
        (item.discountPercent / 100)
      ).toFixed(this.decimal);
      if (parseFloat(item.discount) > parseFloat(item.fee * item.count)) {
        item.discount = 0;
        item.discountPercent = 0;
      }
      this.calcSum();
    },
    checkDiscountPercentPerRow(item) {
      this.totalDiscountType = false;
      this.totalDiscount = 0;
      this.discount = 0;
      if (this.watcher) {
        item.discount = (
          parseFloat(item.fee * item.count) *
          (item.discountPercent / 100)
        ).toFixed(this.decimal);
      }
      if (parseFloat(item.discount) > parseFloat(item.fee * item.count)) {
        item.discount = 0;
        item.discountPercent = 0;
      }
    },
    itemDiscountPercentCalc(item) {
      return (
        (parseFloat(item.discount) /
          parseFloat(item.fee * (item.count && item.count > 0 ? item.count : 1))) *
        100
      );
      /*         const denominator = parseFloat(item.fee) * (item.count && item.count > 0 ? item.count : 1)
        if (!denominator) return 0

        const percent = (parseFloat(item.discount) / denominator) * 100
        return Number(percent.toFixed(2)) */
    },
    checkCount(item) {
      if (
        this.type === "sell" ||
        this.type === "presale" ||
        this.type === "returnPurchase" ||
        this.type === "returnSell"
      ) {
        var productStock =
          item.product && item.product.stock ? parseFloat(item.product.stock.count) : 0;
        if (
          this.type !== "returnSell" &&
          item.product &&
          item.product.type === "product" &&
          this.$store.state.negative_inventory === "no" &&
          parseFloat(item.count) >
            productStock +
              parseFloat(this.$route.name !== "presaleEdit" ? item.countEdit || 0 : 0)
        ) {
          this.snakbarText = this.$t("alert-inventory-is-not-enough");
          this.snakbarColor = "pink";
          this.snakbar = true;
          // item.count = 0
        }
        if (
          !this.comeFromCopy &&
          this.$route.name !== "presaleEdit" &&
          item.product &&
          this.priceType === "formulaPrice"
        ) {
          if (this.type === "sell" || this.type === "presale") {
            if (!this.resolveFormulaFee(item)) {
              this.getPrice(item);
            }
          }
        }
        if (this.type === "returnSell") {
          this.getPrice(item);
        }
      }
      this.scheduleCalcSum();
    },
    removegroup() {
      var app = this;
      app.selected.map(function (value, key) {
        app.remove(value, key);
      });
    },
    onTableUpdate(value) {
      this.compositeTableData = value;
    },
    sanitizeSerialItems(items) {
      const isOut = this.serialFlow === "out";
      return (items || []).map((item) => {
        const next = { ...item };
        delete next._serialProductId;
        delete next.serialOptions;
        if (isOut) {
          next.serial_ids = (item.serials || [])
            .map((serial) => serial && serial.id)
            .filter((id) => id != null);
          delete next.serials;
        }
        return next;
      });
    },
    buildInvoiceSubmitPayload() {
      const payload = { ...this.$data };
      delete payload.serials;
      delete payload.serial_ids;
      delete payload.serialCancelToken;
      delete payload.serialDialog;
      delete payload.serialItem;
      delete payload.serialsLoading;
      delete payload.serialPage;
      delete payload.serialLastPage;
      delete payload.serialSearch;
      delete payload.serialRequestId;
      payload.items = this.sanitizeSerialItems(this.items);
      return payload;
    },
    create(options = {}) {
      if (this.isLoading) return false;
      // Mobile may pass { skipFormValidation: true } after its own validation sheet.
      // Desktop must keep the original fail-closed form check unchanged.
      const skipFormValidation = options && options.skipFormValidation === true;
      // Remove empty placeholder rows before form validation (DOM updates on nextTick)
      this.items = this.items.filter((item) => !!item.product);
      if (!this.items.length) {
        this.snakbarText = this.$t("first you should add some items");
        this.snakbarColor = "pink";
        this.snakbar = true;
        return false;
      }
      if (!this.account) {
        this.snakbarText = this.$t("alert-select-customer");
        this.snakbarColor = "pink";
        this.snakbar = true;
        return false;
      }
      this.$nextTick(() => {
        if (!skipFormValidation && (!this.$refs.form || !this.$refs.form.validate())) {
          this.notifyFormValidationFailed("pink");
          return false;
        }
        var app = this;
        app.snakbar = false;
        app.isLoading = true;
        app.$axios
          .post(this.$endpoint + "invoice", app.buildInvoiceSubmitPayload())
          .then((res) => {
            res = res.data;
            if (res.status === "success") {
              app.snakbarText = app.$t("registered");
              app.snakbarColor = "green";
              app.snakbar = true;
              const filePicker = app.getInvoiceFilePicker();
              if (filePicker && app.attachments) {
                filePicker.create(res.data.id);
              }
              // Capture before clearForm — navigation must not depend on cleared state.
              const invoiceType = app.type;
              const invoiceUid = (res.data && (res.data.uid || res.data.id)) || null;
              const useMobileSuccess = !app.isDesktopLayout;
              const printType = app.printType;
              app.$emit("close", app.$route);
              app.clearForm();
              if (invoiceType === "sell" || invoiceType === "presale") {
                // Mobile: same invoicePrint route (permissions) + mobileSuccess UI.
                // Desktop: unchanged print routes.
                if (useMobileSuccess) {
                  app.$router.push({
                    name: "invoicePrint",
                    params: { id: invoiceUid },
                    query: {
                      mobileSuccess: "1",
                      type: invoiceType,
                    },
                  });
                } else if (printType === "normal") {
                  // Desktop: open the print module on the list page.
                  app.$router.push({
                    name: invoiceType + "List",
                    query: { printInvoice: invoiceUid },
                  });
                } else {
                  app.$router.push({
                    name: "invoiceRollprint",
                    params: { id: invoiceUid },
                  });
                }
              } else {
                app.$emit("close", app.$route);
                app.goTo(invoiceType + "List");
              }
            } else {
              app.snakbarText = app.$t("error");
              app.snakbarColor = "pink";
              app.snakbar = true;
            }
          })
          .catch((err) => {
            if (err.response && err.response.status === 409) {
              this.$store.commit("SET_PLAN_DIALOG", true);
            }
            this.serverErrorHandeler(err);
          })
          .finally(() => {
            this.isLoading = false;
          });
        this.isInvoiceCreated = true;
      });
    },
    update() {
      var app = this;
      app.items = app.items.filter((item) => !!item.product);
      app.snakbar = false;
      app.isLoading = true;
      app.$axios
        .put(
          this.$endpoint + "invoice/" + this.$route.params.id,
          app.buildInvoiceSubmitPayload()
        )
        .then((res) => {
          res = res.data;
          const filePicker = app.getInvoiceFilePicker();
          if (filePicker) {
            filePicker.create(res.data.id);
          }
          app.$emit("close", app.$route);
          app.clearForm();
          app.goTo(app.type + "List");
        })
        .catch((err) => {
          this.serverErrorHandeler(err);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    show() {
      this.isFirstLoad = true;
      var app = this;
      app.loading = true;
      app.watcher = false;
      app.resetSharedProductEdit();
      app.$axios
        .get(this.$endpoint + "invoice/" + this.$route.params.id + "/edit", {
          params: {
            id: this.$route.params.id,
          },
        })
        .then((res) => {
          app.$nextTick(() => {
            res = res.data;
            app.id = res.id;
            app.currency = res.currency;
            app.decimal = res.currency ? res.currency.decimal : 0;
            app.currency_amount = res.currency_amount;
            app.number = res.number;
            app.officialNumber = res.official_number;
            app.content = res.content;
            app.customFields = res.custom_fields;
            app.pattern = res.pattern;
            app.invoicePattern = res.invoicePattern;
            app.contractNumber = res.contractNumber;
            app.date = res.date;
            app.refInvoice = res.refInvoice;
            app.given = res.given;
            app.type = res.type;
            app.items = res.article;
            if (res.priceType || res.price_type) {
              app.priceType = res.priceType || res.price_type;
            }
            (app.items || []).forEach((item) => {
              app.hydrateItemSerials(item);
              if (item.countEdit == null) {
                item.countEdit = item.count;
              }
              // create uid for fake changeProduct in each row
              item._boundProductId = item.product ? item.product.id : null;
              if (!item._uid) {
                item._uid = `edit-${item.id || Math.random().toString(36).slice(2)}`;
              }
            });
            app.notifications = res.notifications;
            app.account = res.customer;
            app.attachments = res.attachments;
            app.editCompositeTableData = [...res.compositeTableData];
            app.entrepot = res.entrepot ? res.entrepot.entrepot : null;
            app.dueDate = res.due_date;
            app.branch = res.branch;
            app.payments = res.payments;
            app.credit = res.credit;
            app.credit_status = res.creditStatus;
            app.seller = res.seller;
            app.commissionAmount = res.commissionAmount;
            app.checks = res.checks;
            app.prevCredit = res.credit;
            app.status = res.last_status ? res.last_status.status : null;
            app.discount = res.discount;
            app.plan = res.plan ? res.plan.plan : null;
            app.compositeTableData = res.compositeTableData;
            app.totalDiscount = res.discount;
            app.investors =
              res.entrepot && res.entrepot.investors ? res.entrepot.investors : null;
            app.items.map(function (value, index) {
              if (value.discount && value.discount > 0) {
                app.checkDiscountEdit = true;
              }
            });
            if (!app.checkDiscountEdit) {
              app.discountEdit = res.discount;
            }
            // app.totaltax = res.tax
            if (res.tax > 0) {
              app.taxStatus = "active";
              app.taxPercent = res.tax_percent;
            }

            if (res.tags) {
              app.tag = res.tags;
              app.more = true;
            }
            if (!this.entrepot && res.entrepotIntegrator) {
              this.entrepot = res.entrepotIntegrator;
            }
            // Warm shared product autocomplete ASAP (before render delay)
            app.$nextTick(() => {
              app.warmSharedProductAutocomplete();
            });
            setTimeout(function () {
              app.render = true;
            }, 1000);
            setTimeout(function () {
              app.watcher = true;
              app.updatePrice();
            }, 3000);
            app.calcSum();
          });
        })
        .catch((err) => {
          this.serverErrorHandeler(err);
        })
        /* .finally(() => (app.loading = false )) */
        .finally(() => {
          app.loading = false;
        });
    },
    clearForm() {
      this.resetSharedProductEdit();
      this.selected = [];
      this.render = true;
      this.isFirstLoad = true;
      this.watcher = false;
      this.bodyStatus = false;
      this.printDialog = false;
      this.deletDialog = false;
      this.showClearing = true;
      this.showSelect = false;
      this.showProductList = false;
      this.clearingStatus = false;
      this.filter = false;
      this.cashAmount = null;
      this.valid = true;
      this.number = null;
      this.invoicePattern = 1;
      this.contractNumber = null;
      this.pattern = 1;
      this.bank = null;
      this.given = null;
      this.attachments = null;
      this.investors = null;
      this.payments = null;
      this.seller = null;
      this.commissionPercent = null;
      this.commissionAmount = null;
      this.checks = null;
      this.officialNumber = null;
      this.account = null;
      this.dueDate = null;
      this.credit_status = false;
      this.userCredit = null;
      this.remainInvoice = null;
      this.credit = null;
      this.editCompositeTableData = [];
      this.compositeTableData = [];
      // this.date = null
      // this.currency_amount = null
      this.content = null;
      this.model = null;
      this.from = 1;
      this.taskDialog = null;
      this.id = null;
      this.status = null;
      this.tag = null;
      this.temp = null;
      this.deleteItem = null;
      this.sellStatus = null;
      this.items = [];
      this.dialog = null;
      this.timer = 0;
      this.isLoading = false;
      this.snakbar = false;
      this.taskId = null;
      this.snakbarText = null;
      this.loading = false;
      this.search = null;
      this.discountPercent = false;
      this.percentDiscountStatus = false;
      this.taxStatus = false;
      this.totalCount = 0;
      this.discount = 0;
      this.totalDiscount = 0;
      this.totalTax = 0;
      this.totalFee = 0;
      this.sumRow = 0;
      this.sum = 0;
      this.totalDiscountType = false;
      this.discountModeDialog = false;
      this.pendingHeaderDiscount = null;
      this.snapshotHeaderDiscount = null;
      this.snapshotHeaderDiscountPercent = null;
      this.headerDiscountInputKey = 0;
      this._headerDiscountModeSubmitted = false;
      this._vaznDistributeJustApplied = false;
      this.getInvoiceNumber();
      this.addRow();
      // Mobile layout has no desktop v-form ref — guard so create() navigation is not aborted.
      if (this.$refs.form && typeof this.$refs.form.resetValidation === "function") {
        this.$refs.form.resetValidation();
      }
    },
    openOptionsDialog(value) {
      this.optionDialogType = value;
    },
    totalAmount(value) {
      this.totalPayment = value;
    },
    invoiceRemain(value) {
      this.remainInvoice = value;
    },
    selectTaxOption(item) {
      this.selectedTaxOption = item.value;
      if (item.value == "active") {
        this.taxStatus = "active";
      } else {
        this.taxStatus = "deactive";
      }
    },
    //get and set tax config
    getTaxToggleConfig() {
      if (this.$route.params.id) return;
      var app = this;
      app.$axios
        .get(app.$endpoint + "panel-ui", {
          params: { key: "selectedTaxOption" },
        })
        .then((res) => {
          const data = res?.data?.data || res?.data || {};
          const value = data?.value;

          if (value === "deactive") {
            app.taxStatus = "deactive";
            app.selectedTaxOption = "deactive";
          } else {
            app.taxStatus = "active";
            app.selectedTaxOption = "active";
          }
        })
        .catch(() => {
          app.taxStatus = "active";
          app.selectedTaxOption = "active";
        });
    },
    setTaxToggleConfig(val) {
      this.$axios.post(this.$endpoint + "panel-ui", {
        key: "selectedTaxOption",
        value: val,
      });
    },
    loadInvoiceTableColumnSettings() {
      var app = this;
      if (!app.headers || !app.headers.length) return;
      loadColumnSettings(app, app.invoiceColumnPersistKey).then(function (snapshot) {
        if (!snapshot || !snapshot.length) return;
        applyColumnSettings(app.headers, snapshot, {
          locked: ["actions", "row", "product"],
          anchor: "product",
        });
        app.$forceUpdate();
      });
    },
    checkTaxStatus() {
      if (this.totalTax == 0) {
        this.selectedTaxOption = "deactive";
        this.taxStatus = "deactive";
      } else {
        this.selectedTaxOption = "active";
        this.taxStatus = "active";
      }
    },
  },
};
</script>

<style scoped>
.invoice-page--mobile {
  overflow: hidden;
  position: relative;
  display: flex;
  flex-direction: column;
  background: #fff;
}
.invoice-page--mobile > * {
  flex: 1 1 auto;
  min-height: 0;
  width: 100%;
}
</style>
